import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'out-failure',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './failure.component.html',
  styleUrl: './failure.component.scss',
})
export class FailureComponent {
  constructor(private router: Router, private route: ActivatedRoute) {}

  goToHome() {
    this.router.navigate(['/account']);
  }

  tryAgain() {
    // Get the listing ID from query params if available
    const listingId = this.route.snapshot.paramMap.get('listing_id');
    if (listingId) {
      this.router.navigate(['/your-tesla/listing/checkout', listingId]);
    } else {
      this.router.navigate(['/your-tesla/listing/checkout']);
    }
  }
}
